const backgroundVideo = require('../../../images/bgvideo.mp4')

const BackgroundVideo = () => (
    <video autoPlay playsInline muted preload="true" loop id="bgvid" className="bg-videos">
        <source src={backgroundVideo} type="video/mp4"/>
    </video>
)

export default BackgroundVideo